import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { PaytableFactory } from "slotworks/components/factories/paytable-factory";
import { AgsPaytableComponent } from "../ags-paytable-component";

export class AgsPaytableFactory extends PaytableFactory implements ComponentFactory {
    public build(): AbstractComponent {
        return new AgsPaytableComponent(this.config);
    }
}
